import dynamicfunction from '../../../utils/dynamicfunction';
import ViewReverse from '../../../components/ViewReverse';
import { cn, formatNumbers } from '../../../utils/utils';
import Text from '../../../components/Text';
import { fontSizes } from '../../../constants/constants';
import SarSymbol from '../../../components/SarSymbol';

const HoldingView = ({ holdings, fund, getContent }) => {
  const { TextWeight, direction, isArabic } = dynamicfunction();

  return (
    <>
      <div className='w-full rounded-xl overflow-hidden border border-grey'>
        <ViewReverse
          className={cn(
            ' items-center px-5 py-4 border-b transition-all duration-500 cursor-pointer',
            'border-b-grey flex-col',
          )}
        >
          <Text text={isArabic ? fund?.fundName_AR : fund?.fundName_EN} size={fontSizes.h16} weight={TextWeight.medium} color='text-black' className={"w-full mb-3"} isTruncate={false} />
          <div dir={direction} className='grid grid-cols-2 gap-y-3 w-full'>
            <ViewReverse className={'flex-col items-start'}>
              <Text
                text={formatNumbers(fund?.holdingUnits, 0)}
                size={fontSizes.h14}
                className={'flex-1'}
                color='text-primary'
                weight={TextWeight.medium}
              />
              <Text
                text={getContent('number_of_units_owned')}
                size={fontSizes.h12}
                className={'flex-1'}
                weight={TextWeight.regular}
                color={'text-silver'}
              />
            </ViewReverse>
            <ViewReverse className={'flex-col items-start'}>
              <ViewReverse>
                <SarSymbol color={'text-primary'} />
                <Text
                  text={formatNumbers(fund?.costOfUnitsOwned)}
                  size={fontSizes.h14}
                  weight={TextWeight.medium}
                  color='text-primary'
                />
              </ViewReverse>
              <Text
                text={getContent('cost_of_units_owned')}
                size={fontSizes.h12}
                className={'flex-1'}
                weight={TextWeight.regular}
                color={'text-silver'}
              />
            </ViewReverse>
            <ViewReverse className={'flex-col items-start'}>
              <ViewReverse>
                <SarSymbol color={'text-primary'} />
                <Text
                  text={formatNumbers(fund?.nav)}
                  size={fontSizes.h14}
                  weight={TextWeight.medium}
                  color='text-primary'
                />
              </ViewReverse>
              <Text
                text={getContent('nav')}
                size={fontSizes.h12}
                className={'flex-1'}
                weight={TextWeight.regular}
                color={'text-silver'}
              />
            </ViewReverse>
            <ViewReverse className={'flex-col items-start'}>
              <ViewReverse>
                <SarSymbol color={'text-primary'} />
                <Text
                  text={formatNumbers(fund?.currentNav)}
                  size={fontSizes.h14}
                  weight={TextWeight.medium}
                  color='text-primary'
                />
              </ViewReverse>
              <Text
                text={getContent('current_nav')}
                size={fontSizes.h12}
                className={'flex-1'}
                weight={TextWeight.regular}
                color={'text-silver'}
              />
            </ViewReverse>
          </div>
        </ViewReverse>
      </div>
      <div className='w-full rounded-xl overflow-hidden border border-grey mt-5'>
        <ViewReverse
          className={cn(
            'transition-all flex-col duration-500 overflow-hidden',
            'max-h-[500px]',
          )}
        >
          <div className={'flex items-center px-5 py-3 border-b border-b-grey'}>
            <Text
              text={getContent('invested_capital')}
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-black'
            />
            <Text
              text={formatNumbers(holdings?.invested_capital)}
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-primary'
              weight={TextWeight.medium}
            />
          </div>
          <div className={'flex items-center px-5 py-3 border-b border-b-grey'}>
            <Text
              text={getContent('dividend_distributions')}
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-black'
            />
            <Text
              text={formatNumbers(holdings?.dividened_distribution)}
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-primary'
              weight={TextWeight.medium}
            />
          </div>
          <div className={'flex items-center px-5 py-3 border-b border-b-grey'}>
            <Text
              text={getContent('market_value')}
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-black'
            />
            <Text
              text={formatNumbers(holdings?.market_value)}
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-primary'
              weight={TextWeight.medium}
            />
          </div>
          <div className={'flex items-center px-5 py-3 border-b border-b-grey'}>
            <Text
              text={getContent('total_return')}
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-black'
            />
            <Text
              text={formatNumbers(holdings?.total_return) + " %"}
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-primary'
              weight={TextWeight.medium}
              dir={"ltr"}
            />
          </div>
          <div className={'flex items-center px-5 py-3 border-b border-b-grey'}>
            <Text
              text={getContent('unrealized_gains')}
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-black'
            />
            <Text
              text={
                holdings?.unrealized_loss_gain > 0
                  ? formatNumbers(
                    holdings.unrealized_loss_gain)
                  : '-'
              }
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-primary'
              weight={TextWeight.medium}
              dir={"ltr"}
            />
          </div>
          <div className={'flex items-center px-5 py-3 border-b border-b-grey'}>
            <Text
              text={getContent('unrealized_loss')}
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-black'
            />
            <Text
              text={
                holdings?.unrealized_loss_gain < 0
                  ? formatNumbers(
                    holdings.unrealized_loss_gain)
                  : '-'
              }
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-primary'
              weight={TextWeight.medium}
              dir={"ltr"}
            />
          </div>
          <div className={'flex items-center px-5 py-3 border-b border-b-grey'}>
            <Text
              text={getContent('net_gains')}
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-black'
            />
            <Text
              text={formatNumbers(holdings?.net_gain)}
              size={fontSizes.h14}
              className={'flex-1'}
              color='text-primary'
              weight={TextWeight.medium}
              dir={"ltr"}
            />
          </div>
        </ViewReverse>
      </div>
    </>
  );
};

export default HoldingView;
